import Portada from '../components/Portada';
import Extra from '../components/Extra';

export default function Inicio() {
	return (
		<div id='inicio'>
			<Portada />
			<Extra />
		</div>
	);
}
